//APP CONSTANTS
import appConstants from "../_constants/appConstants";

//HELPERS
import { updateObject } from "../_utils";
import userConstants from "../_constants/userConstants";
const initialState = {
  header: {
    title: "UI Elements",
    description:
      "Individual form controls automatically receive some global styling",
    show: true
  },
  breadcrumbs: [
    { label: "Dashboard", link: "/a" },
    { label: "UI Kits", link: "/a" },
    { label: "UI Elements", link: "/a" }
  ],
  sidebar: { minimized: false, collapsed: false },
  rightBar: false,
  footer: { fixed: true, collapsed: false },
  toasts: []
};
/* ---------------------------------------------------
 MINIMIZE SIDEBAR
  ----------------------------------------------------- */
const minimizeSidebar = (state, action) => {
  return updateObject(state, {
    sidebar: updateObject(state.sidebar, { minimized: action.payload })
  });
};
/* ---------------------------------------------------
 COLLAPSE SIDEBAR
  ----------------------------------------------------- */
const collapseSidebar = (state, action) => {
  return updateObject(state, {
    sidebar: updateObject(state.sidebar, { collapsed: action.payload })
  });
};
/* ---------------------------------------------------
 TOGGLE RIGHTBAR
  ----------------------------------------------------- */
const toggleRightbar = (state, action) => {
  return updateObject(state, { rightBar: action.payload });
};
/* ---------------------------------------------------
 TOGGLE FIXED FOOTER
  ----------------------------------------------------- */
const toggleFixedFooter = (state, action) => {
  return updateObject(state, {
    footer: updateObject(state.footer, { fixed: action.payload })
  });
};
/* ---------------------------------------------------
 TOGGLE COLLAPSED FOOTER
  ----------------------------------------------------- */
const toggleCollapsedFooter = (state, action) => {
  return updateObject(state, {
    footer: updateObject(state.footer, { collapsed: action.payload })
  });
};
/* ---------------------------------------------------
 UPDATE PAGE HEADER
  ----------------------------------------------------- */
const updatePageHeader = (state, action) => {
  const { title, description, show = true } = action.payload;
  return updateObject(state, {
    header: { title, description, show }
  });
};
/* ---------------------------------------------------
 UPDATE BREADCRUMB MENU ITEMS
  ----------------------------------------------------- */
const updateBreadcumbMenuItems = (state, action) => {
  return updateObject(state, {
    breadcrumbs: action.payload
  });
};
/* ---------------------------------------------------
 SHOW TOAST
  ----------------------------------------------------- */
const showToast = (state, action) => {
  return updateObject(state, {
    toasts: [action.payload, ...state.toasts]
  });
};
/* ---------------------------------------------------
   HIDE TOAST
    ----------------------------------------------------- */
const hideToast = (state, action) => {
  return updateObject(state, {
    toasts: state.toasts.filter(toast => toast.id !== action.payload)
  });
};
/* ---------------------------------------------------
      SIGN OUT
  ----------------------------------------------------- */
const signOut = (state, action) => {
  return initialState;
};
/* ---------------------------------------------------
      REDUCER
  ----------------------------------------------------- */
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case appConstants.MINIMIZE_SIDEBAR:
      return minimizeSidebar(state, action);
    case appConstants.COLLAPSE_SIDEBAR:
      return collapseSidebar(state, action);
    case appConstants.TOGGLE_RIGHTBAR:
      return toggleRightbar(state, action);
    case appConstants.TOGGLE_FIXED_FOOTER:
      return toggleFixedFooter(state, action);
    case appConstants.TOGGLE_COLLAPSED_FOOTER:
      return toggleCollapsedFooter(state, action);
    case appConstants.UPDATE_PAGE_HEADER:
      return updatePageHeader(state, action);
    case appConstants.UPDATE_BREADCRUMB_MENU_ITEMS:
      return updateBreadcumbMenuItems(state, action);
    case appConstants.SHOW_TOAST:
      return showToast(state, action);
    case appConstants.HIDE_TOAST:
      return hideToast(state, action);
    case userConstants.SIGN_OUT:
      return signOut(state, action);
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/_reducers/AppReducer.js